import mixpanel, { track } from 'mixpanel-browser';
import { MIX_PANEL_KEY, TEST, STAGING, DEV } from '../constants';

mixpanel.init(MIX_PANEL_KEY);
const env_check = !DEV && !STAGING && !TEST;
const identifyId =
  localStorage.getItem('mix_panel') || `${Date.now()}${Math.floor(Math.random() * 10000)}`;
localStorage.setItem('mix_panel', identifyId);
mixpanel.identify(identifyId);
mixpanel.people.set({
  userId: identifyId,
});
const actions = {
  identify: (id: string) => {
    if (env_check) mixpanel.identify(id);
  },
  alias: (id: string) => {
    if (env_check) mixpanel.alias(id);
  },
  track: (name: string, props: any) => {
    if (env_check) mixpanel.track(name, props);
  },
  people: {
    set: (props: any) => {
      if (env_check) mixpanel.people.set(props);
    },
  },
};

export const Mixpanel = actions;
